enum RequiredDocumentDetailTypeCodeEnum {
    PROOF_OF_INCOME = "PROOF_OF_INCOME",
    PAYSLIP = "PAYSLIP",
    LAST_MONTH_BANK_ACCOUNT_STATEMENT_SALARY_INCLUDED = "LAST_MONTH_BANK_ACCOUNT_STATEMENT_SALARY_INCLUDED",
}

export default RequiredDocumentDetailTypeCodeEnum;
